import { getDashboardUrl } from "@areahub/config";

export const auth0Provider = {
  id: "auth0",
  name: "Auth0",
  type: "oauth",
  signinUrl: `${getDashboardUrl()}/api/auth/signin/auth0`,
  callbackUrl: `${getDashboardUrl()}/api/auth/callback/auth0`,
};
